var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from 'react-query';
import { useChuckClientContext } from './useChuckClientContext';
import { useAPI } from './useAPI';
import { useProfileContext } from './useProfileContext';
import { useUserContext } from './useUserContext';
export const useUserAuthentication = () => {
    const { post } = useAPI();
    const { client } = useChuckClientContext();
    const { setProfile, setPermissions, setIsLoading } = useProfileContext();
    const { setUser, setToken, setConfig } = useUserContext();
    return useMutation(({ email, password }) => post({
        url: email && password ? '/users/login' : '/users/identify',
        data: email && password ? { email, password } : {},
        misc: { withCredentials: true }
    }).then((res) => res.data), {
        onSuccess: (data) => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            if (client.storeTokenLocally) {
                yield client.Storage.setItem('gptk', data.token);
                yield client.Storage.setItem('udid', data.udid);
            }
            setUser(data.user);
            setConfig(data.config);
            setToken(data.token);
            if (data.profile)
                setProfile(data.profile);
            if (data.permissions)
                setPermissions(data.permissions);
            setIsLoading(false);
        }),
        onError: (err) => {
            var _a, _b;
            if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) !== 403 && ((_b = err.response) === null || _b === void 0 ? void 0 : _b.status) !== 401)
                client.captureException(err);
            setIsLoading(false);
        }
    });
};
//# sourceMappingURL=useUserAuthentication.js.map